import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { userFavoritesReselector as stateSelector } from 'reduxModules/users/selectors'
import { favoritesDispatchers as dispatchSelector } from 'reduxModules/users/dispatchers'
import { favoritesStatus } from 'reduxModules/users'
import Tutorial from '../../../generic/CourseSummary'
import Teacher from '../../../generic/ProfileSummary'
import BlogPost from '../../../Blog/BlogPosts/BlogPost/_lazy'
import getArtistTagline from '../../../utils/getArtistTagline'
import './styles.css'

export class FavoritesList extends Component {
  componentDidMount() {
    this.props.loadFavorites()
  }

  render() {
    if (this.props.status !== favoritesStatus.success) return null

    const results = this.props.favorites.results
    const tutorials = _.filter(results, { favoritedModel: 'videotutorial' })
    const artists = _.filter(results, { favoritedModel: 'artist' })
    const posts = _.filter(results, { favoritedModel: 'post' })

    return (
      <div id="FavoriteList" className="account-section">
        {tutorials.length > 0 && (
          <div className="courses">
            <h3 className="account-section__title">courses</h3>
            <section className="tutorials-list-content">
              {tutorials.map((t) => (
                <Tutorial
                  className="tutorial"
                  key={`tutorial-${t.favoritedObject.id}`}
                  slug={t.favoritedObject.slug}
                  summary={t.favoritedObject.title}
                  teacher={t.favoritedObject.artist.title}
                  teacherSlug={t.favoritedObject.artist.slug}
                  title={t.favoritedObject.title}
                  thumb={t.favoritedObject.photo.boxThumb}
                  new={t.favoritedObject.new}
                />
              ))}
            </section>
          </div>
        )}
        {artists.length > 0 && (
          <div className="teachers">
            <h3 className="account-section__title">teachers</h3>
            <div className="artists-list-content">
              {artists.map((artist, artistIndex) => (
                <Teacher
                  className="artist"
                  key={`artist-${artistIndex}`}
                  name={artist.favoritedObject.title}
                  photo={artist.favoritedObject.photo.boxThumb}
                  slug={artist.favoritedObject.slug}
                  tagline={getArtistTagline(artist.favoritedObject.tags)}
                />
              ))}
            </div>
          </div>
        )}
        {posts.length > 0 && (
          <div className="posts">
            <h3 className="account-section__title">blog articles</h3>
            <div className="blog-posts-content">
              {posts.map((blogPost, blogPostIndex) => (
                <BlogPost
                  key={blogPostIndex}
                  {...blogPost.favoritedObject}
                  showSocial={false}
                />
              ))}
            </div>
          </div>
        )}
        {results && results.length === 0 && (
          <div className="no-results">
            <span>You don&apos;t have any favorites yet.</span>
          </div>
        )}
      </div>
    )
  }
}

FavoritesList.propTypes = {
  loadFavorites: PropTypes.func.isRequired,
  favorites: PropTypes.objectOf(PropTypes.any),
  status: PropTypes.string
}

FavoritesList.defaultProps = {
  favorites: { results: [] },
  status: ''
}

export default connect(
  stateSelector,
  dispatchSelector
)(FavoritesList)
